import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
} from '@mui/material';
import { type EspecieEditDialogProps } from '../types/especie';
import { useEspecieForm } from '../hooks/useEspecieForm';

export const EditEspecie: React.FC<EspecieEditDialogProps> = ({
  open,
  especieId,
  onClose,
  onSave,
  title = 'Editar Especie',
}) => {
  const {
    formData,
    errors,
    loading,
    isValid,
    handleChange,
    handleSubmit,
    resetForm,
  } = useEspecieForm(especieId, onSave);

  React.useEffect(() => {
    if (open && !especieId) {
      resetForm();
    }
  }, [open, especieId, resetForm]);

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        component: 'form',
        onSubmit: handleFormSubmit,
      }}
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label="Nombre Común"
            name="nombreComun"
            value={formData.nombreComun}
            onChange={handleChange}
            error={!!errors.nombreComun}
            helperText={errors.nombreComun}
            required
            fullWidth
            autoFocus
          />

          <TextField
            label="Nombre Científico"
            name="nombreCientifico"
            value={formData.nombreCientifico}
            onChange={handleChange}
            error={!!errors.nombreCientifico}
            helperText={errors.nombreCientifico}
            required
            fullWidth
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          type="submit"
          variant="contained"
          disabled={!isValid || loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Guardando...' : 'Guardar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};